import { BridgeComponent } from "@hotwired/hotwire-native-bridge"

/**
 * Native overflow / action menu (Hotwire Native bridge).
 *
 * @example
 *   <div data-controller="bridge--menu" data-bridge-title="More">
 *     …
 *   </div>
 */
export default class extends BridgeComponent {
  static component = "menu"

  connect() {
    super.connect()
    if (!this.enabled) return

    const title = this.bridgeElement.bridgeAttribute("title") || this.bridgeElement.title
    this.send("connect", { title })
  }
}
